import axios from 'axios'
// import { sha256 } from 'js-sha256'
// import { MD5 } from '../../utils/md5'
// import store from '../../store'
import { Toast } from 'vant'
import { appEncrypt, appDecrypt } from './prehttp'

const axiosInstance = axios.create()
axiosInstance.defaults.timeout = 10000
axiosInstance.defaults.retry = 3
axiosInstance.defaults.retryDelay = 1000
axiosInstance.defaults.baseURL = process.env.VUE_APP_BASE_API
Toast.allowMultiple()
let loading
// Add a request interceptor
axiosInstance.interceptors.request.use(
  async function(config) {
    let ruquestData = await appEncrypt(config)
    const querys = ruquestData.headers
    // Do something before request is sent
    // 设置头部信息
    config.headers.token = ruquestData.token
    // 设置请求头
    for (let key in querys) {
      config.headers[key] = querys[key]
    }
    config.headers.sid = window.localStorage.getItem('sid')
    let version = window.localStorage.getItem('version')
    if (version) {
      config.headers.version = version
    }
    let platform = window.localStorage.getItem('platform')
    if (platform) {
      config.headers.platform = platform
    }
    // 设置请求参数信息
    const params = ruquestData.body || {}
    console.log('params', config.data)
    config.data = params
    config.transformRequest = [
      function(data) {
        let ret = ''
        for (let it in data) {
          if (data.hasOwnProperty(it)) {
            ret +=
              encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
          }
        }
        return ret
      }
    ]
    if (!loading && config.url != '/api/pay/orderlineinfo') {
      //加载动画
      loading = Toast.loading({
        mask: false, //控制遮罩层是否显示
        overlayClass: 'loading',
        className: 'loading',
        message: '加载中...',
        duration: 0,
        forbidClick: false
      })
    }
    return config
  },
  function(error) {
    // Do something with request error
    return Promise.reject(error)
  }
)

// Add a response interceptor
axiosInstance.interceptors.response.use(
  async function(response) {
    if (loading) loading.clear()
    loading = null
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    if (response.status === 200) {
      if (response.data.code != 0) {
        Toast(response.data.rtnInfo || '系统异常')
        return Promise.reject()
      }
      if (response.data && response.data.data) {
        let result = await appDecrypt(response)
        console.log(`${response.config.url}`, result.data)
        return result.data
      }
      return response.data
    }
    Toast('系统异常')
    return response
  },
  function(error) {
    if (loading) loading.clear()
    loading = null
    Toast('系统异常')
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    return Promise.reject(error)
  }
)

export default axiosInstance
